import React, { useState } from "react"
import "./HeroSection.css"

const HeroSection = () => {
  const [videoError, setVideoError] = useState(false)
  const scrollToBooking = () => {
    const element = document.getElementById("booking-form")
    const headerOffset = 80 // Account for sticky header height to land exactly at green background start
    const elementPosition = element.offsetTop
    const offsetPosition = elementPosition - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <section className='hero-section'>
      <div className='container'>
        <nav className='hero-nav sticky-nav'>
          <div className='hero-logo' onClick={scrollToTop}>
            <img
              src={require("../assets/images/cordova-logo.png")}
              alt='Cordova Franchising'
              className='logo-image'
            />
          </div>
          <button className='hero-nav-btn' onClick={scrollToBooking}>
            Book a Call
          </button>
        </nav>
      </div>

      <div className='hero-main'>
        <div className='container'>
          <div className='hero-content'>
            <h1 className='hero-title'>
              From <span className='highlight'>Corporate Climber</span> to{" "}
              <span className='highlight'>Business Owner</span> <br />
              <span> Launch Your Own Staffing Franchise in</span>
              <span className='highlight'> 90 Days</span>
            </h1>

            <p className='hero-subtitle'>
              Use the Cordova Franchise System to own a high‑margin,
              low‑overhead staffing business backed by a nationally recognized
              Inc 5000 brand.{" "}
            </p>

            <div className='hero-video-section'>
              <p className='video-cta'>CLICK BELOW TO WATCH FIRST!</p>
              <div className='video-container'>
                {!videoError ? (
                  <video
                    className='custom-video'
                    controls
                    preload='metadata'
                    poster='/assets/videos/cordova-vsl-poster.jpg'
                    width='560'
                    height='315'
                    onError={() => setVideoError(true)}
                  >
                    <source
                      src='/assets/videos/cordova-vsl.mp4'
                      type='video/mp4'
                    />
                    <source
                      src='/assets/videos/cordova-vsl.webm'
                      type='video/webm'
                    />
                    <source
                      src='/assets/videos/cordova-vsl.ogg'
                      type='video/ogg'
                    />
                    <p>
                      Your browser doesn't support HTML5 video. Please upgrade
                      your browser or{" "}
                      <button
                        type='button'
                        className='inline-link'
                        onClick={scrollToBooking}
                      >
                        book a call directly
                      </button>
                      .
                    </p>
                  </video>
                ) : (
                  <div className='video-placeholder'>
                    <div className='placeholder-content'>
                      <div className='placeholder-icon'>🎥</div>
                      <h3>VSL Video Coming Soon</h3>
                      <p>
                        Upload your VSL video as 'cordova-vsl.mp4' in the
                        public/assets/videos/ folder
                      </p>
                      <button
                        className='btn-secondary'
                        onClick={scrollToBooking}
                      >
                        Skip Video - Book Call Now
                      </button>
                    </div>
                  </div>
                )}
                <p className='video-description'>
                  Watch the $13.7M Proven Model Overview
                </p>
              </div>
              <button
                className='btn-primary hero-btn'
                onClick={scrollToBooking}
              >
                Book a 20-min walkthrough call
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
